export default "https://cdn-static.gokick.com/assets/c3e2404f2f1be1cd3bf75e8d7804f871d91db3b2/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";